import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import React from "react";
import Layout from "./Layout";

export default function AboutUs() {
  return (
    <Layout>
      <div className="relative isolate overflow-hidden bg-white lg:overflow-visible lg:px-0">
        <div className="mx-auto gap-y-16 ">
          <div className="lg:px-8">
            <div className="lg:pr-4">
              <div className="lg:max-w-lg">
                <p className="text-base font-semibold leading-7 text-indigo-600">
                  ABOUT US
                </p>
                <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                  Running Count History
                </h1>
              </div>
            </div>
          </div>
          <div className="lg:mx-auto lg:w-full lg:px-8">
            <div className="lg:pr-4">
              <div className="text-base leading-7 text-gray-700">
                <p className="mt-8">
                  Running Count was started in 1977 by Dennis Fairall and his
                  wife Janet. They moved the business to Windsor when Dennis
                  became the track and field coach for the University of
                  Windsor. After not receiving his bib numbers in time for an
                  event, Dennis started to investigate more reliable options. He
                  discovered that the most reliable option was printing them
                  himself. Dennis and Janet operated the business until they
                  stepped down in 2005. Running Count was purchased by Darryl
                  Currie, a former athlete of Dennis'. Since 2005 many new
                  products have been added, including full colour bibs,
                  personalized bibs, adhesive bibs, a wide variety of other
                  print products and a full line of track and field equipment.
                  Our goal has always been to provide great customer service and
                  create the best quality product at the best price.
                </p>
                <p className="mt-8">
                  Running Count is based in Windsor, Ontario, Canada, just
                  minutes from Detroit, Michigan. Our location helps us to ship
                  bib numbers quickly and efficiently throughout North America.
                  We pride ourselves on being able to print and deliver your bib
                  numbers quickly.
                </p>

                <p className="mt-8">
                  All of our bib numbers are printed on Tyvek®. The durable
                  nature of Tyvek® makes our bib numbers applicable to a wide
                  variety of events, including marathons, track and field
                  competitions, mud runs, adventure races, team tryouts, skiing
                  and biking events, triathlons and many other uses.
                </p>
                <p className="mt-8">
                  We hope this gives you a better understanding of our
                  high-quality product and our dedication to providing
                  exceptional customer service.
                </p>
                <p className="mt-8">Good luck with your event!</p>
                <p className="mt-8">Running Count Inc.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
